import numeral from 'numeral'
import type { InputNumberProps } from 'rc-input-number'

import type { NUMBER_FORMATTER_TYPE, NUMBER_REGEX_TYPE } from '@/constants/common'
import { EMPTY_NUMBER, NUMBER_REGEX } from '@/constants/common'

export interface CheckIsNumberOptions {
  min?: number
  max?: number
}

export const checkIsNumber = (
  value: string | number,
  type: NUMBER_REGEX_TYPE,
  options?: CheckIsNumberOptions
): boolean => {
  if (EMPTY_NUMBER.includes(value)) return true
  const _originalValue = `${value}`

  switch (type) {
    case 'DECIMAL_UNSIGNED':
      return NUMBER_REGEX.DECIMAL_UNSIGNED(options?.min, options?.max).test(_originalValue)
    case 'DECIMAL_SIGNED':
      return NUMBER_REGEX.DECIMAL_SIGNED(options?.min, options?.max).test(_originalValue)
    default:
      return NUMBER_REGEX[type].test(_originalValue)
  }
}

export const formatNumber = (val: number | string, decimalCount = 2) => {
  if (EMPTY_NUMBER.includes(val)) return '-'

  const valNum = Number(val)

  if (Number.isNaN(valNum)) return val

  return valNum.toLocaleString('en-US', {
    minimumFractionDigits: 0,
    maximumFractionDigits: decimalCount
  })
}

export const NUMBER_FORMATTER: {
  [key in NUMBER_FORMATTER_TYPE]: {
    formatter: InputNumberProps['formatter']
    parser?: InputNumberProps['parser']
  }
} = {
  normal: {
    formatter: val => (EMPTY_NUMBER.includes(val) ? '' : numeral(val).format('0,0.[000000]'))
  },
  percent: {
    formatter: val => (EMPTY_NUMBER.includes(val) ? '%' : numeral(val).divide(100).format('0,0.[000000]%')),
    //@ts-ignore
    parser: val => val.replace('%', '')
  }
}

export const numberFormatter = (val?: any, type: NUMBER_FORMATTER_TYPE = 'normal') => {
  //@ts-ignore
  return NUMBER_FORMATTER[type].formatter(val, {
    userTyping: false,
    input: val
  })
}

// ...existing code...

export const ceilingUSD = (amount: number, multiple: number = 5): number => {
  if (multiple === 0) {
    throw new Error('Multiple cannot be zero');
  }
  
  // Nếu < 1$: giữ nguyên 2 chữ số thập phân
  if (amount < 1) {
    return Math.round(amount * 100) / 100;
  }
  
  // Nếu >= 1$ và < 10$: làm tròn lên 1 chữ số thập phân
  if (amount >= 1 && amount < 10) {
    return Math.ceil(amount * 10) / 10;
  }
  
  // Nếu >= 10$: làm tròn lên theo bội số (số nguyên)
  return Math.ceil(amount / Math.abs(multiple)) * Math.abs(multiple);
};

export const ceilingIDR = (amount: number, multiple: number = 5000): number => {
  if (multiple === 0) {
    throw new Error('Multiple cannot be zero');
  }
  
  // < 1000 IDR: giữ nguyên
  if (amount < 1000) {
    return Math.round(amount);
  }
  
  // ≥ 1000 IDR: làm tròn lên theo bội số (5000, 10000...)
  return Math.ceil(amount / Math.abs(multiple)) * Math.abs(multiple);
};

export const roundNumberToK = (num: number): string => {
  if (num >= 1_000_000) {
    return (num / 1_000_000).toFixed(1).replace(/\.0$/, '') + 'M';
  }
  if (num >= 1_000) {
    return (num / 1_000).toFixed(1).replace(/\.0$/, '') + 'K';
  }
  return num.toString();
};